export interface ReturnValues {
    belop1: number,
    belop2: number | undefined,
    belop3: number | undefined,
}

export function formatNumber(tall: any, locale: string): string {
    let tallSomString: string = tall.toString();
    if (locale === 'en-US') {
        tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
    } else {
        tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
    }

    return tallSomString;
}

export function RegnUtVisning3(inntekt: number, id36: number, id7: number): ReturnValues {

    // Beløp 1 = (A1 – [ID36]) x 5% x 11 
    // Maxverdi beløp 1 = [beløp2]
    // Beløp 2 = ([ID7] x 330) x 40%

    let returBelop: ReturnValues = { belop1: 0, belop2: 0, belop3: 0 }; // FIX SUGGESTION: 0 OR 

    returBelop.belop1 = Math.round((inntekt - id36) * 0.05 * 11);
    returBelop.belop2 = Math.round((id7 * 330) * 0.4);

    if (returBelop.belop1 > returBelop.belop2)
        returBelop.belop1 = returBelop.belop2;

    return returBelop;
}

export function RegnUtVisning4(inntekt: number, id49: number, id7: number): ReturnValues {
    // Beløp 3 = (A1 – [ID49]) x 5% x 6 
    // Maxverdi beløp 3 = beløp 4
    // Beløp 4 = ([ID7] x 180) x 40%

    let returBelop: ReturnValues = { belop1: 0, belop2: 0, belop3: undefined };

    returBelop.belop1 = Math.round((inntekt - id49) * 0.05 * 6);
    returBelop.belop2 = Math.round((id7 * 180) * 0.4);

    if (returBelop.belop1 > returBelop.belop2)
        returBelop.belop1 = returBelop.belop2;

    return returBelop;
}

export function RegnUtVisning5(inntekt: number, id36: number, id7: number): ReturnValues {
    // Beløp 5 = (A1 – [ID36]) x 5% x 11 x 0,75  
    // Maxverdi beløp 5 = ([ID7] x 330) x 0,4 x 0,75
    // Beløp 6 = (A1 – [ID36]) x 5% x 11 x 0,67 
    // Maxverdi beløp 6 = ([ID7] x 330) x 0,4 x 0,67
    // Beløp 7 = (A1 – [ID36]) x 5% x 11 x 0,50
    // Maxverdi beløp 7 = ([ID7] x 330) x 0,4 x 0,50

    let returBelop: ReturnValues = { belop1: 0, belop2: 0, belop3: undefined };

    returBelop.belop1 = Math.round((inntekt - id36) * 0.05 * 11 * 0.75);
    let maxBelop1: number = Math.round((id7 * 330) * 0.4 * 0.75);

    if (returBelop.belop1 > maxBelop1)
        returBelop.belop1 = maxBelop1;

    returBelop.belop2 = Math.round((inntekt - id36) * 0.05 * 11 * 0.67);
    let maxBelop2: number = Math.round((id7 * 330) * 0.4 * 0.67);

    if (returBelop.belop2 > maxBelop2)
        returBelop.belop2 = maxBelop2;

    returBelop.belop3 = Math.round((inntekt - id36) * 0.05 * 11 * 0.5);
    let maxBelop3: number = Math.round((id7 * 330) * 0.4 * 0.5);

    if (returBelop.belop3 > maxBelop3)
        returBelop.belop3 = maxBelop3;

    return returBelop;
}

export function RegnUtVisning6(inntekt: number, id49: number, id7: number): ReturnValues {
    // Beløp 8 = (A1 – [ID49]) x 5% x 6 x 0,67
    // Maxverdi beløp 8 = ([ID7]x 180) x 0,4 x 0,67
    // Beløp 9 = (A1 – [ID49]) x 5% x 6 x 0,50
    // Maxverdi beløp 9 = ([ID7]x 180)] x 0,4 x 0,5
    // Beløp 10 = (A1 – [ID49]) x 5% x 6 x 0,33
    // Maxverdi beløp 10 = ([ID7]x 180) x 0,4 x 0,33


    let returBelop: ReturnValues = { belop1: 0, belop2: 0, belop3: undefined };

    returBelop.belop1 = Math.round((inntekt - id49) * 0.05 * 6 * 0.67);
    let maxBelop1: number = Math.round((id7 * 180) * 0.4 * 0.67);

    if (returBelop.belop1 > maxBelop1)
        returBelop.belop1 = maxBelop1;

    returBelop.belop2 = Math.round((inntekt - id49) * 0.05 * 6 * 0.5);
    let maxBelop2: number = Math.round((id7 * 180) * 0.4 * 0.5);

    if (returBelop.belop2 > maxBelop2)
        returBelop.belop2 = maxBelop2;

    returBelop.belop3 = Math.round((inntekt - id49) * 0.05 * 6 * 0.33);
    let maxBelop3: number = Math.round((id7 * 180) * 0.4 * 0.33);

    if (returBelop.belop3 > maxBelop3)
        returBelop.belop3 = maxBelop3;

    return returBelop;
}

export function RegnUtVisning7(inntekt: number, id36: number): ReturnValues {
    // Beløp 11 = (A1 – [ID36]) x 5% x 11 
    // Maxverdi beløp 11: Ingen maxverdi

    let returBelop: ReturnValues = { belop1: 0, belop2: undefined, belop3: undefined };
    returBelop.belop1 = Math.round((inntekt - id36) * 0.05 * 11);

    return returBelop;
}

export function RegnUtVisning8(inntekt: number, id49: number): ReturnValues {
    // Beløp 12 = (A1 – [ID36]) x 5% x 6 
    // Maxverdi beløp 12: Ingen maxverdi

    let returBelop: ReturnValues = { belop1: 0, belop2: undefined, belop3: undefined };
    returBelop.belop1 = Math.round((inntekt - id49) * 0.05 * 6);

    return returBelop;
}

export function RegnUtVisning9(inntekt: number, id36: number): ReturnValues {
    // Beløp 13 = (A1 – [ID36]) x 5% x 11 x 0,5  
    // Maxverdi beløp 13 = ingen maxverdi

    let returBelop: ReturnValues = { belop1: 0, belop2: undefined, belop3: undefined };
    returBelop.belop1 = Math.round((inntekt - id36) * 0.05 * 11 * 0.5);

    return returBelop;
}

export function RegnUtVisning10(inntekt: number, id49: number): ReturnValues {
    // Beløp 14 = (A1 – [ID49]) x 5% x 6 x 0,5 
    // Maxverdi beløp 14 = ingen maxverdi

    let returBelop: ReturnValues = { belop1: 0, belop2: undefined, belop3: undefined };
    returBelop.belop1 = Math.round((inntekt - id49) * 0.05 * 6 * 0.5);

    return returBelop;
}